import type { OFFERS_TYPE, Tab, VITRINS_OFFERS_TYPE } from '@sravni/ugc/lib/specialOffers/types';

import { PRODUCTS_INFO } from '../constants/productsInfoData';
import type { Condition } from '../hooks/useProductData';

export interface OfferTab {
  key: Tab<VITRINS_OFFERS_TYPE>;
  label: string;
  generalLink: string;
  linkToOneProduct: string;
  getConditions: (offer) => Condition[];
  advertisingCategory: string;

  buttonAction?: string;
  getVerticalWidgetConditions?: (offer) => Condition[];
}

export const getProductData = (type: OFFERS_TYPE): OfferTab => {
  return PRODUCTS_INFO[type];
};
